<template>
	<div>
		<div class="product-category">
			<div class="product-category-item">
				<div class="product-category-title">分&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;类：</div>
				<div @click="changeCategory('')" :class="active==''?'active':''">不限</div>
				<div @click="changeCategory(index+1)" v-for="(item,index) in $product[0]" :class="active==index+1?'active':''">{{item}}</div>
			</div>
			<div class="product-category-line"></div>
			<div class="product-category-item">
				<div class="product-category-title">搜&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;索：</div>
				<div>
					<div class="search-panel">
						<el-input @clear="search" @keyup.enter.native="search" v-model="keywords" prefix-icon="el-icon-search" class="search-input" clearable type="text" placeholder="请输入关键词搜索"/>
						<div class="search-button" @click="search">搜索</div>
					</div>
				</div>
			</div>
		</div>
		<el-empty description="暂无数据" v-if="needLists.length==0"></el-empty>
		<div class="product-content">
			<el-row :gutter="10">
				<el-col :span="7" v-for="(item,index) in needLists">
					<el-card :body-style="{ padding: '0px' }" shadow="hover" :class="item.id==active?'active':''">
						<div @click="showDetail(item.id)" style="padding: 20px 20px 10px 20px">
							<div class="product-label">{{$product[0][item.root-1]}}<div class="pproduct-text color-glay right"><i class="el-icon-view"></i><span>{{item.read_times}}</span></div></div>
							<div class="product-name" style="-webkit-box-orient:vertical">{{item.name}}</div>
							<div class="product-desc-panel">
								<div class="product-desc">发布日期：{{item.date||'--'}}</div>
								<div class="product-desc">有效期限：{{item.expires||'--'}}</div>
								<div class="product-desc">预算价格：{{item.price||'--'}}</div>
							</div>
							<div class="product-bottom">
								<span class="product-text color-glay">{{item.company}}</span>
							</div>
						</div>
					</el-card>
				</el-col>
			</el-row>
		</div>
	</div>
</template>
<script>
	import {Api} from "../../utils/axios.js"
	export default {
		data(){
			return{
				active:'',
				keywords:'',
				needLists:[],
				page:1
			}
		},
		components: {
			
		},
		methods: {
			changeCategory(index){
				this.active=index
				this.page = 1
				this.needLists = []
				this.loadData()
			},
			search(){
				this.page = 1
				this.needLists = []
				this.loadData()
			},
			loadData(){
				let params = {};
				params.root = this.active
				params.keywords = this.keywords
				params.page = this.page
				Api('need/list',params).then((res) => {
					console.log(res)
					if(res.code==200){
						for(var i=0;i<res.result.list.length;i++){
							this.needLists.push(res.result.list[i])
						}
					}else{
						this.$message.error(res.msg)
					}
				})
			},
			showDetail(id){
				this.active = id
				let routeData = this.$router.resolve({ path: 'needDetail', query: {id:id}});
				window.open(routeData.href, '_blank');
			}
		},
		created:function(){
			this.loadData()
		},
		mounted(){
			window.addEventListener('scroll', this.lazyLoading);
		}
	}
</script>
<style scoped>
	
</style>